import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../features/userLogInSlice';
import scheduleReducer from '../features/scheduleSlice'
import predictReducer from '../features/predictSlice'

export const store = configureStore({
  reducer: {
    auth: userReducer,
    schedule : scheduleReducer,
    predict : predictReducer
  },
});
